var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.49998H16.1667C16.1667 3.58331 15.4167 2.83331 14.5 2.83331H9.5C8.58333 2.83331 7.83333 3.58331 7.83333 4.49998H7C5.58333 4.49998 4.5 5.58331 4.5 6.99998V18.6666C4.5 20.0833 5.58333 21.1666 7 21.1666H17C18.4167 21.1666 19.5 20.0833 19.5 18.6666V6.99998C19.5 5.58331 18.4167 4.49998 17 4.49998ZM9.5 4.49998H14.5V6.16665H9.5V5.33331V4.49998ZM17 19.5C17.5 19.5 17.8333 19.1666 17.8333 18.6666V6.99998C17.8333 6.49998 17.5 6.16665 17 6.16665H16.1667C16.1667 7.08331 15.4167 7.83331 14.5 7.83331H9.5C8.58333 7.83331 7.83333 7.08331 7.83333 6.16665H7C6.5 6.16665 6.16667 6.49998 6.16667 6.99998V18.6666C6.16667 19.1666 6.5 19.5 7 19.5H17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.990c5f8a.svg";
export { ForwardRef as ReactComponent };